module.exports = __webpack_public_path__ + "img/google-translate.02293117.svg";